// extracted by mini-css-extract-plugin
export default {"teaser":"CaseFunctionalities--teaser--3FZKT","listItem":"CaseFunctionalities--listItem--15XOE"};